const unreadMessagesCount = state => state.unreadMessagesCount;
const currentConversation = state => state.currentConversation;
const userTypingData = state => state.userTypingData;
const chatRooms = state => state.chatRooms;
const currentChatRoomId = state => state.currentChatRoomId;

export default {
  unreadMessagesCount,
  currentConversation,
  userTypingData,
  chatRooms,
  currentChatRoomId,
};
